import {
  Box,
  Grid,
} from "@mui/material";
import { useState } from "react";

import MobileTradeWrapper from "./components/MobileTradeWrapper";
import TradeHead from "./components/TradeHead";
import useIsMobileView from "hooks/useIsMobileView";

function BasicTradeFormWrapper({
  setShowMarketDrawer,
  coinMarketDetails,
}) {
  const isMobileView = useIsMobileView();

  const [showTradingView, setShowTradingView] = useState(false);

  const handleShowOrHideTradingView = () => {
    setShowTradingView((v) => !v);
  };

  return (
    <>
      <Grid container>
        {isMobileView && (
          <Grid item xs={12}>
            <TradeHead
              coinMarketDetails={coinMarketDetails}
              setShowMarketDrawer={setShowMarketDrawer}
              handleShowOrHideTradingView={handleShowOrHideTradingView}
            />
          </Grid>
        )}
      </Grid>

      <Box>
        <MobileTradeWrapper
          handleShowOrHideTradingView={handleShowOrHideTradingView}
          showTradingView={showTradingView}
          coinMarketDetails={coinMarketDetails}
          setShowMarketDrawer={setShowMarketDrawer}
        />
      </Box>

    </>
  );
}

export default BasicTradeFormWrapper;
